import { initializeApp } from "firebase/app";
import { getAuth, onAuthStateChanged, signInWithEmailAndPassword, signOut, createUserWithEmailAndPassword, updateEmail, reauthenticateWithCredential, updatePassword} from "firebase/auth";
import { EmailAuthProvider } from "firebase/auth/web-extension";
import { getFirestore,  doc, addDoc, setDoc, getDoc, getDocs, collection, query, where, or, and, documentId, onSnapshot, deleteDoc, updateDoc, limit, orderBy } from "firebase/firestore";
import { useState, useEffect } from "react";
import { getMessaging, getToken, onMessage, isSupported } from "firebase/messaging";

const firebaseConfig = {
	apiKey: "AIzaSyDs8e2VCssyFxUFoQ6-05L7rPdqE_lTmms",
	authDomain: "chautauquainterconnect.firebaseapp.com",
	databaseURL: "https://chautauquainterconnect-default-rtdb.firebaseio.com",
	projectId: "chautauquainterconnect",
	storageBucket: "chautauquainterconnect.appspot.com",
	messagingSenderId: "872590941210",
	appId: "1:872590941210:web:cb6497c2489bc4ac1645a3",
	measurementId: "G-J15WRNVRB9"
};
const vapidkey = "BMWdirh4kIThnQGE1w7D-3OJ5YLZHhknafLYOy_hNeYx68AkcjDu4m677ZDFV4-gMNKBdxC-4COfwZLPNKpPmVU";

const firebaseApp = initializeApp(firebaseConfig)

const auth = getAuth(firebaseApp)
const firestore = getFirestore(firebaseApp)

const messaging = await isSupported() ? getMessaging(firebaseApp) : null;

if(messaging != null) {
	onMessage(messaging, (payload) => {
		console.log('Message received. ', payload);
		const notificationConfig = JSON.parse(payload.data.notification)
		console.log('Nofication Config: ', notificationConfig)

		const notificationTitle = 'Background Message Title';
		const notificationOptions = {
			body: 'Background Message body.',
			icon: '/chautauquaicon.png',
			badge: 'data:image/png;base64,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'
		};
	});
}

export const ACCOUNT_LOADING = 0x23;

export const ACCOUNT_TYPES = ['Chautauqua', 'Event Staff', 'MANNA Worldwide'];
export const ACCOUNT_AREAS = {
	chautauqua: ['Administration', 'Food Service', 'Housekeeping', 'Intern', 'Maintenance', 'Recreation', 'Volunteer'],
	event: ['Event Director', 'Event Staff', 'Event Volunteer'],
	manna: ['MANNA Staff', 'MANNA Missionary']
}
export const PERMISSIONS = ['view-home', 'is-admin', 'view-all-events'];

var locations_global = null;

export function useAuth() {

	const [currentUser, setCurrentUser] = useState(ACCOUNT_LOADING);
	const [currentUserData, setCurrentUserData] = useState(ACCOUNT_LOADING);

	useEffect(() => {
		const unSubscribe = onAuthStateChanged(auth, (user) => {setCurrentUser(user)});
		return unSubscribe;
	}, []);

	useEffect(() => {
		if(currentUser == null || currentUser === ACCOUNT_LOADING) {
			setCurrentUserData(null);
		} else {
			return onSnapshot(doc(firestore, 'users', currentUser.uid), (doc) => 
				{
					var userData = doc.data();
					userData.id = currentUser.uid;
					setCurrentUserData(userData); 
				});
		}		
	}, [currentUser]);

	return [currentUser, currentUserData];
}
export function useHasPendingAccountTypeAreaRequest() {

	const [currentUser, currentUserData] = useAuth();
	const [hasRequest, setHasRequest] = useState(false);

	useEffect(() => {
		if(currentUser == null || currentUser === ACCOUNT_LOADING) {
			setHasRequest(null);
		} else {
			return onSnapshot(collection(firestore, 'account_taa_requests'),
				(snapshot) => {
					var requestExists = false;

					for(const doc of snapshot.docs) 
						requestExists = requestExists || doc.data()?.account_data?.id === currentUserData.id;

					setHasRequest(requestExists);
				}, 
				(error) => {
					console.error(error);
				})
		}		
	}, [currentUser, currentUserData]);

	return hasRequest;
}


export function signIntoFirebase(email, password, navigation, path, onError) {
	if(email === '' || password === '')
		onError(Error('empty-credidentals'));
	else
		signInWithEmailAndPassword(auth, email, password)
			.then(() => {
				if(navigation !== null && path !== null)
					navigation(path);
			})
			.catch((err) => {
				onError(err);
			});
}
export function signOutOfFirebase() {
	signOut(auth).catch((err) => {console.error(err)});
}


export function createAccountRequest(requestInfo) {
	return addDoc(collection(firestore, "user_requests"), requestInfo);
}
export function listenToAccountRequest(changeListener) {

	return onSnapshot(collection(firestore, 'user_requests'),
		(snapshot) => {
			let requests = [];
			for(const doc of snapshot.docs) {
				let data = doc.data();
				data.timestamp = doc._document.createTime.timestamp.seconds;
				data.id = doc.id;
				requests.push(data)
			}

			requests.sort((o1, o2) => o1.timestamp - o2.timestamp);

			changeListener(requests);
		}, 
		(error) => {
			console.error(error);
		})

}
export function denyAccountRequest(request) {
	deleteDoc(doc(firestore, 'user_requests', request.id));
}
export function approveAccountRequest(id, account_type, account_area, permissions) {
	updateDoc(doc(firestore, 'user_requests', id), {account_type, account_area, permissions, pending: 'Awaiting Email'});
}
export function getAccountRequestDetails(id) {
	const docRef = doc(firestore, "user_requests", id);
	return getDoc(docRef);
}
export function createNewAccount(request, password, birthday, profilePic) {
	createUserWithEmailAndPassword(auth, request.email, password).then((o1) => {
		setDoc(doc(firestore, "users", o1.user.uid),
			{
				first_name: request.first_name,
				last_name: request.last_name,
				email: request.email,
				phone_number: request.phone_number,
				account_type: request.account_type,
				account_area: request.account_area,
				permissions: request.permissions,
				birthday: birthday,
				profile_pic: profilePic
			}).then(() => {
				deleteDoc(doc(firestore, 'user_requests', request.id));
			})
	})
	
}

export function changePassword(oldPassword, newPassword, onFail, onSuccess) {
	reauthenticateWithCredential(auth.currentUser, EmailAuthProvider.credential(auth.currentUser.email, oldPassword))
			.then(() => {
				updatePassword(auth.currentUser, newPassword);
				onSuccess();
			}).catch((error) => onFail(error));
}

export function updateAccountData(data, accountID = undefined) {

	if(accountID === undefined)
		accountID = auth.currentUser.uid;

	if(data.email !== auth.currentUser.email)
		updateEmail(auth.currentUser, data.email).then(
			() => {
				updateDoc(doc(firestore, 'users', accountID), data);
			}).catch(() => {
				alert('Stale Login\nPlease log back in and try again.');
				signOutOfFirebase();
			})
	else
		updateDoc(doc(firestore, 'users', accountID), data);
}
export function requestAccountTypeAndAreaChange(newArea, newType, accountData) {
	let data = {
		old_area: accountData.account_area,
		old_type: accountData.account_type,
		new_area: newArea,
		new_type: newType,
		account_data: {
			first_name: accountData.first_name,
			last_name: accountData.last_name,
			email: accountData.email,
			phone_number: accountData.phone_number,
			id: accountData.id
		}
	}

	return addDoc(collection(firestore, "account_taa_requests"), data);
}


export async function checkPermission(permission) {
	console.log('Is current user null? ' + (auth.currentUser == null));
	if(auth.currentUser == null)  {
		return false;
	}

	console.log('Checking User Permission: ' + permission);

	const permissionQuery = query(collection(firestore, "users"), and(where(documentId(), "==", auth.currentUser.uid), where("permissions", "array-contains", permission)))
	const querySnapshot = await getDocs(permissionQuery);
	return querySnapshot.docs.length === 1;
}

export async function getCampLocations() {

	if(locations_global != null)
		return locations_global;

	const docRef = doc(firestore, "camp_locations", "locations");
	const docSnap = await getDoc(docRef);
	
	let locations = []

	for(const location in docSnap.data())
		locations.push(location);

	locations_global = locations;

	return locations.sort();
}

export function useLocations() {
	const [locations, setLocations] = useState([]);

	useEffect(() => {
		const document = doc(firestore, "camp_locations", "locations");
		const unSubscribe = onSnapshot(document, (snapshot) => {
			var locationList = [];

			for(const location in snapshot.data()) {
				locationList.push({name: location, categories: snapshot.data()[location]});
			}

			setLocations(locationList);
		});

		return unSubscribe;
	}, [])

	return locations;
}

export async function getReservationDetails(id) {
	const docRef = doc(firestore, "reservations", id);
	const docSnap = await getDoc(docRef);

	return docSnap.data();
}


export async function getUpcomingMatrices() {
	
	const upcomingMatrixQuery = query(collection(firestore, "reservations"), and(where("matrix_link", "!=", ""), where("end_date", ">=", new Date())))
	const querySnapshot = await getDocs(upcomingMatrixQuery);	

	let upcomingMatricies = {};

	querySnapshot.forEach((doc) => {
		upcomingMatricies[doc.id] = doc.data();
	});
	
	return upcomingMatricies;
}
export async function getEventsInRange(startDate, endDate) {

	const reservationsQuery = query(collection(firestore, "reservations"), or(
		and(
			where("end_date",   ">=", startDate),
			where("start_date", "<=", startDate)
		),
		and(
			where("start_date", ">=", startDate),
			where("start_date", "<=", endDate)
		)
	));

	const reseverations  = await getDocs(reservationsQuery);

	let events = {
		camp: {},
		retreat: {},
		day_event: {},
		reservation: {}
	};

	reseverations.forEach((doc) => {
		if(!doc.id.startsWith('test'))
			events[doc.data().classification][doc.id] = doc.data();
	});

	return events;
}
export function useReservationList() {
	const [reservations, setReservations] = useState([]);

	useEffect(() => {
		const q = query(collection(firestore, 'reservations'), where('classification', '==', 'reservation'), where("end_date", ">=", new Date()));
		const unSubscribe = onSnapshot(q, (snapshot) => {
			var reservationList = [];

			for(const doc of snapshot.docs)
				reservationList.push(doc.data())

			setReservations(reservationList);
		});

		return unSubscribe;
	}, [])

	

	return [reservations]
}
export function useCurrentEvent() {
	const [currentEvent, setCurrentEvent] = useState();

	useEffect(() => {
		
		const earlyToday = new Date();
		earlyToday.setHours(1);
		earlyToday.setMinutes(0);

		const lateTomorrow = new Date();
		lateTomorrow.setDate(lateTomorrow.getDate() + 1);
		lateTomorrow.setHours(23);
		lateTomorrow.setMinutes(59);

		const q = query(collection(firestore, 'reservations'), 
			where('start_date', '<', lateTomorrow), 
			where("end_date", ">", earlyToday),
			where("classification", "!=", 'reservation'),
			limit(4));

		const unSubscribe = onSnapshot(q, (snapshot) => {
			if(snapshot.docs.length === 1)
				setCurrentEvent(snapshot.docs[0].data());
			
			else if(snapshot.docs.length > 1) {
				const now = new Date().getTime();

				const getTimeDiff = (event) => {
					let startMLS = event.start_date.seconds * 1000;
					let endMLS = event.end_date.seconds * 1000;

					if(now < endMLS && now > startMLS)
						return 0;
					else
						return Math.min(Math.abs(now - startMLS), Math.abs(now - endMLS));
				}

				var closestEvent = snapshot.docs[0].data();
				var closestTime = getTimeDiff(closestEvent);
				var timeDiff;

				for(let i = 1; i < snapshot.docs.length; i++) {
					if (timeDiff = getTimeDiff(snapshot.docs[i].data()) < closestTime) {
						closestTime = timeDiff;
						closestEvent = snapshot.docs[i].data();
					}
				}

				setCurrentEvent(closestEvent);
			} else
				setCurrentEvent(null)
		});

		return unSubscribe;
	}, [])	

	return currentEvent;
}
export async function getPastAndCurrentEvents() {
	const docRef = doc(firestore, "reservations", "0000_compiled_data");
	const docSnap = await getDoc(docRef);

	var events = docSnap.data().past_current_events;

	events.sort((e1, e2) => {
		return e2.start_date.seconds - e1.start_date.seconds;
	});

	return events;
}


export function updateCheckInOutForm(id, data, onSuccess, onFail) {
	if (id === undefined) {
		addDoc(collection(firestore, 'check_in_out'), data)
			.then((ref) => onSuccess(ref))
			.catch((err) => onFail(err));
	} else {
		updateDoc(doc(firestore, 'check_in_out', id), data)
			.then((ref) => onSuccess(ref))
			.catch((err) => onFail(err));
	}
}
export async function getCheckInOutForm(id) {
	const docRef = doc(firestore, "check_in_out", id);
	const docSnap = await getDoc(docRef);

	return docSnap.data();
}
export function useCheckInOutFormList(eventId) {
	const [forms, setForms] = useState([]);

	useEffect(() => {
		if(eventId === null) {
			const c = collection(firestore, 'check_in_out');
			const unSubscribe = onSnapshot(c, (snapshot) => {
				var formList = [];

				for(const doc of snapshot.docs) {
					const data = doc.data();
					data.id = doc.id;
					formList.push(data);
				}

				setForms(formList);
			});

			return unSubscribe;

		} else if (eventId !== undefined) {
			const q = query(collection(firestore, 'check_in_out'), 
							where('event_id', '==', eventId));

			const unSubscribe = onSnapshot(q, (snapshot) => {
				var formList = [];

				for(const doc of snapshot.docs) {
					const data = doc.data();
					data.id = doc.id;
					formList.push(data);
				}

				setForms(formList);
			});

			return unSubscribe;
		} else {
			setForms([])
		}
		
	}, [eventId])

	return forms;
}



export function updateReservation(id, data) {
	if(id === undefined) {
		addDoc(collection(firestore, 'reservations'), data).then((docRef) => {
			updateDoc(docRef, {id: docRef.id});
		})
	} else {
		updateDoc(doc(firestore, 'reservations', id), data);
	}
}
export function deleteReservation(id) {
	deleteDoc(doc(firestore, 'reservations', id));
}


export function createContactRequest(request) {
	return addDoc(collection(firestore, "contact_requests"), request);
}


export function getMessagingToken() {
	return getToken(messaging, { vapidKey: vapidkey });
}


export async function subscribeToMessagingTopics(token, topics) {
	console.log('Token', token)
	const docRef = doc(firestore, "notifications", "topics");

	const topicSubscriptions = (await getDoc(docRef)).data();

	for(const topic in topicSubscriptions) {

		if(topics.includes(topic)) {
			// Add subscripttion from topic if it is NOT in the list
			if(!topicSubscriptions[topic].includes(token)) 
				topicSubscriptions[topic].push(token);
		} else {
			// Remove subscription from topic if it is in the list
			if(topicSubscriptions[topic].includes(token))
				topicSubscriptions[topic].splice(topicSubscriptions[topic].indexOf(token), 1);
		}
	}

	updateDoc(docRef, topicSubscriptions);
}

export async function unsubscribeFromAllMessagingTopics(token) {
	const docRef = doc(firestore, "notifications", "topics");

	const topicSubscriptions = (await getDoc(docRef)).data();

	for(const topic in topicSubscriptions) {		
		if(topicSubscriptions[topic].includes(token))
			topicSubscriptions[topic].splice(topicSubscriptions[topic].indexOf(token), 1);
	}

	updateDoc(docRef, topicSubscriptions);
}



export function requestPaymentLink(billData, onLinkReceived) {
	addDoc(collection(firestore, "payment_request"), billData)
		.then((docRef) => {
			const unsubscribe = onSnapshot(doc(firestore, "payment_request", docRef.id), 

				(snap) => {
					const data = snap.data();

					if(data.status === "received link") {
						onLinkReceived(data.link, data.linkId);
						unsubscribe();
					}
				});
		})
}
export function removePaymentLink(id) {
	console.log(`Remove: ${id}`);
	updateDoc(doc(firestore, 'payment_request', id), {status: 'remove link'});
}
export function useCheckInCosts() {
	const [costs, setCosts] = useState(undefined);

	useEffect(() => {
		getDoc(doc(firestore, 'payment_request', 'payment_costs')).then(
			(ref) => {setCosts(ref.data());}
		)
	}, []);

	return costs;
}